<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <div class="touch-content">
        <div class="touch-content-lt">
          <JssRichText class="touch-title" :field="fields?.title" tag="h2" />
          <JssRichText class="touch-subtitle" :field="fields?.subtitle" />
          <div class="touch-list" v-if="fields?.list?.length > 0">
            <SiteLink
              :link="utils.sc.getFieldObj(item, 'link')"
              class="touch-list-item"
              v-for="item in fields?.list"
              :key="item.id"
            >
              <div class="touch-list-item-content">
                <div
                  class="touch-list-item-icon"
                  :style="{ background: item?.fields?.iconBgColor?.value }"
                >
                  <Icon :svg="item?.fields?.icon?.value?.svgCode" />
                </div>
                <div class="touch-list-item-text">
                  <JssRichText class="touch-list-item-text-title" :field="item?.fields?.title" />
                  <JssRichText
                    class="touch-list-item-text-subtitle"
                    :field="item?.fields?.subtitle"
                  />
                </div>
              </div>
              <Icon name="arrow-right" />
            </SiteLink>
          </div>
        </div>
        <div class="touch-content-rt">
          <AdaptiveImage
            class="touch-image"
            :field="fields?.image"
            :isBackground="false"
            :lazy-load="false"
            :enableScrollDetection="false"
            :show="true"
          />
        </div>
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'Touch',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'touch'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    return {
      rootClass,
      rootStyle,
      utils,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.touch {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-content {
    display: flex;
    flex-direction: column;
    gap: 24px;

    &-rt {
      order: 1;
      width: 100%;
    }

    &-lt {
      order: 2;
    }
  }

  &-title {
    font-size: 24px;
    font-weight: 700;
    line-height: 1.2;
  }

  &-subtitle {
    font-size: 16px;
    line-height: 1.2;
    margin-top: 16px;
  }

  &-list {
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    &-item {
      display: flex;
      justify-content: space-between;
      background-color: #fdfdfd;
      cursor: pointer;
      border-radius: 16px;
      padding: 24px 10px;

      &:hover {
        background-color: #f1f4f1;
      }

      &-content {
        display: flex;
        gap: 24px;
      }

      &-icon {
        width: 48px;
        height: 48px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &-text {
        display: flex;
        flex-direction: column;
        gap: 8px;

        &-title {
          font-size: 18px;
          font-weight: 700;
          line-height: 1.2;
        }

        &-subtitle {
          font-size: 14px;
          line-height: 1.2;
        }
      }
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-content {
      flex-direction: row;
      gap: 40px;

      &-lt {
        order: 1;
        flex: 1;
      }

      &-rt {
        order: 2;
        width: 538px;
      }
    }

    &-title {
      font-size: 32px;
    }

    &-list {
      margin-top: 32px;

      &-item {
        padding: 24px;
      }
    }
  }
}
</style>
